import { Component, OnInit, ViewChild } from '@angular/core';
import { MemberData } from './catalogue-our-team.model';
import { CatalougeListTeamMembersComponent } from './catalouge-list-team-members/catalouge-list-team-members.component';

@Component({
  selector: 'app-catalouge-our-team',
  templateUrl: './catalouge-our-team.component.html',
  styleUrls: ['./catalouge-our-team.component.scss']
})
export class CatalougeOurTeamComponent implements OnInit {
  tempMemberData = new MemberData()
  @ViewChild(CatalougeListTeamMembersComponent, { static: false })
  catalougeListTeamMembersComponent!: CatalougeListTeamMembersComponent;

  constructor() { }

  ngOnInit() {
  }

  public onTeamEdit(data: MemberData) {
    this.tempMemberData = { ...data };
  }

  public onRefresh() {
    if (this.catalougeListTeamMembersComponent) {
      this.catalougeListTeamMembersComponent.readTeamData();
    } else {
      console.warn('catalougeListTeamMembersComponent is not available');
    }
  }
}
